import { useState, useEffect, useSyncExternalStore, useDeferredValue } from 'react';

import { expVal } from '@confluence/feature-experiments';

const emptySubscribe = () => () => {};
const getClientSnapshot = () => false;
const getServerSnapshot = () => true;

// This hook is used to determine if we should continue to render the server placeholder
// during hydration on the first render to prevent mismatch. If mismatch occurs, hydration
// can break.
export const useRenderServerPlaceholder = (renderServerPlaceholderOnNonHydrate = false) => {
	const isSSRSync = useSyncExternalStore(emptySubscribe, getClientSnapshot, getServerSnapshot);
	// Confluence uses flushSync to force synchronous hydration on Suspense boundaries
	// useDeferredValue prevents useSyncExternalStore from triggering a conflicting synchronous update (see: https://kurtextrem.de/posts/react-uses-hydration)
	const optimizedRenderServerPlaceholder = useDeferredValue(isSSRSync);

	const isTransition = window.__SSR_RENDERED__ === false;
	const [renderServerPlaceholder, setRenderServerPlaceholder] = useState(
		renderServerPlaceholderOnNonHydrate
			? // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
				!isTransition || Boolean(process.env.REACT_SSR)
			: // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
				((window as any)?.__HYDRATABLE__ && !isTransition) || Boolean(process.env.REACT_SSR),
	);

	useEffect(() => {
		if (!expVal('confluence_optimize_render_server_placeholder', 'isEnabled', false)) {
			// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
			if (!process.env.REACT_SSR) {
				setRenderServerPlaceholder(false);
			}
		}
	}, []);

	return expVal('confluence_optimize_render_server_placeholder', 'isEnabled', false)
		? optimizedRenderServerPlaceholder
		: renderServerPlaceholder;
};
